"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable max-len */
/* eslint-disable quotes, indent */
var _default = {
  'inputForm.instruction': 'All fields are required unless marked optional',
  'inputField.label.firstName': 'First name',
  'inputField.label.lastName': 'Last name',
  'inputField.label.fullName': 'Name on card',
  'inputField.label.Email': 'Email',
  'inputField.label.phoneNumber': 'Phone number',
  'inputField.placeholder.firstName': 'John',
  'inputField.placeholder.lastName': 'Doe',
  'inputField.placeholder.fullName': 'John Doe',
  'inputField.placeholder.email': 'john.doe@cashstar.com',
  'inputField.placeholder.phoneNumber': 'Enter phone number',
  'inputField.errorMessage.incompleteField': 'Incomplete field',
  'inputField.errorMessage.exceedsMaxCharacters': 'Exceeds {max} characters',
  'inputField.errorMessage.pleaseEnterAValidFirstName': 'Please enter a valid first name',
  'inputField.errorMessage.pleaseEnterAValidLastName': 'Please enter a valid last name',
  'inputField.errorMessage.pleaseEnterAValidFullName': 'Please enter a valid full name',
  'inputField.errorMessage.invalidAddressValue': 'Please enter a valid address',
  'inputField.errorMessage.invalidCityValue': 'Please enter a valid city',
  'inputField.errorMessage.pleaseEnterAValidEmailAddress': 'Please enter a valid email address',
  'inputField.errorMessage.pleaseEnterAValidPhoneNumber': 'Please enter a valid phone number',
  'inputField.errorMessage.invalidName': 'Please enter a valid Name',
  'header.text.billingInfo': 'Billing information',
  'submitButton.adyen.label': 'Pay now',
  'inputField.label.cardNumber': 'Card number',
  'inputField.label.cardExpiry': 'Exp date (MM/YY)',
  'inputField.label.cardCVV': 'CVV/CVC',
  'inputField.placeholder.cardNumber': 'Card number',
  'inputField.placeholder.cardExpiry': 'MM/YY',
  'inputField.placeholder.cardCVV': '3 or 4 digits',
  'inputField.errorMessage.invalidCardNumber': 'Please enter a valid card number',
  'inputField.errorMessage.invalidCardExpiry': 'Please enter a valid expiry date',
  'inputField.errorMessage.invalidCardCVV': 'Please enter a valid CVV or CVC',
  'inputField.label.saveCardLabel': 'Save for later',
  'inputField.label.makeAsDefaultLabel': 'Mark as default',
  'paymentMethod.paypal.login.initial': 'To complete the checkout via PayPal, please login and validate the payment details',
  'paymentMethod.paypal.login.success': 'Validation successful, please complete the checkout',
  'paymentMethod.zipPay.minCartAmount': 'The minimum order value to use Zip is $35',
  'paymentMethod.zipPay.additionalCharges': 'An additional merchant fee up to {amount} may apply to your order total to use Zip.',
  'paymentMethod.adyen.label': 'Credit/ Debit card and e-banking',
  'paymentMethod.adyen.single.label': 'Credit/ Debit card',
  'paymentMethod.paypal.label': 'PayPal',
  'paymentMethod.zippay.label': 'Zip',
  'paymentMethod.creditCard.label': 'Credit/ Debit card',
  'paymentMethod.googlePay.label': 'Google Pay',
  'paymentMethod.applePay.label': 'Apple Pay',
  'paymentMethod.zippay.preview.message': 'The minimum order value to use Zip is $35',
  "inputField.errorMessage.cardTypeNotSupported": "Card Type is not supported"
};
exports.default = _default;